import { Button, UiLink } from '@nexus/ui';
import { useRouterState } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useModules } from '../modules/context';
import { guideForPage, useVisibleGuides } from './guides';

/**
 * "Anleitung" in the header of every page that has a guide: the guide of the page, the only one
 * of its module, or the module's guides in the help area. Modules only declare their guides.
 */
export function GuideButton() {
  const { t } = useTranslation();
  const guides = useVisibleGuides();
  const modules = useModules();
  const route = useRouterState({
    select: (state) => state.matches.at(-1)?.fullPath as string | undefined,
  });
  const target = route ? guideForPage(guides, modules, route) : null;
  if (!target) return null;
  const href =
    'guideId' in target
      ? `/help/${target.guideId}`
      : `/help?area=${encodeURIComponent(target.area)}`;
  return (
    <Button asChild variant="ghost" icon="book-open" iconOnlyOnPhone>
      <UiLink href={href}>{t('help.button')}</UiLink>
    </Button>
  );
}
